import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

import { TitledCard } from 'Components/';
import { Main } from 'Containers/';
import MPWWebApi from 'API/MPWApi';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { toastSuccess, toastError } from 'Common/ToastHelper';
import CloseSchoolYearForm from './CloseSchoolYearForm';
import { CloseSchoolYearFormEnum } from 'Common/FieldEnum';
import { getGradesAction } from 'State/grades/actions';
import { getGrades } from 'State/selectors';
import { makeOptionsData } from 'Common/FormHelper';

class CloseSchoolYear extends Component {
  static propTypes = {
    stepComplete: PropTypes.func.isRequired,
    prevStep: PropTypes.func.isRequired,
    isComplete: PropTypes.bool.isRequired,
    fiscalYear: PropTypes.number.isRequired,
  };

  state = {
    initialized: false,
    loading: false,
  };

  componentDidMount() {
    this.getGrades();
  }

  getGrades = async () => {
    try {
      await this.props.getGradesAction();
      this.setState({ initialized: true });
    } catch (error) {
      toastError('There was an error getting ');
    }
  };

  getMainProps = () => {
    const { prevStep } = this.props;

    return {
      toolbox: {
        backButtonProps: { shown: true, callback: prevStep },
        shown: true,
      },
    };
  };

  summaryMessage = values => {
    const { fiscalYear, gradeOptions } = this.props;
    const doNoDeleteWithdrawnWithBalance =
      values[CloseSchoolYearFormEnum.DoNotDeleteWithdrawnWithBalance];
    const grades = values[CloseSchoolYearFormEnum.GradeIds]
      .map(x => gradeOptions.find(grade => grade.value === x).text)
      .join(', ');

    return (
      <React.Fragment>
        <ul>
          <li>
            All free and reduced applications for fiscal year {fiscalYear} will
            be closed and archived.
          </li>
          <li>
            All withdrawn students
            {doNoDeleteWithdrawnWithBalance && ' without account balances'}
            {values[CloseSchoolYearFormEnum.ShouldDeleteGrade] && (
              <React.Fragment> and students in {grades}</React.Fragment>
            )}{' '}
            will be deleted
            {!doNoDeleteWithdrawnWithBalance
              ? ' and their balances will be set to zero.'
              : '.'}
          </li>
          <li>All unprocessed scanned applications will be discarded.</li>
        </ul>
        <p>Would you like to continue?</p>
      </React.Fragment>
    );
  };

  closeTheSchoolYear = async values => {
    const { setYesNoDialogProps } = this.props;

    const shouldClose = await new Promise(resolve =>
      setYesNoDialogProps({
        showDialog: true,
        title: 'Close School Year Summary',
        question: this.summaryMessage(values),
        yesCallback: () => resolve(true),
        noCallback: () => resolve(false),
        cancelCallback: () => resolve(false),
      })
    );

    if (shouldClose) {
      const { stepComplete } = this.props;
      this.setState({ loading: true });

      try {
        await MPWWebApi.postGenericInsertUpdate(`closeSchoolYear`, values);
        toastSuccess('Close School Year Started');
        stepComplete();
      } catch (error) {
        toastError(error.response.Title || error.response.Message);
      }

      this.setState({ loading: false });
    }
  };

  render() {
    const { fiscalYear, gradeOptions, isComplete } = this.props;

    return (
      <Main {...this.getMainProps()}>
        <TitledCard title={'Close School Year'}>
          {isComplete ? (
            <Message success>
              <Message.Content>
                <Message.Header>
                  Close School Year {fiscalYear} started.
                </Message.Header>
                You will receive a notification when it is finished. You can
                leave this page without interrupting the progress.
              </Message.Content>
            </Message>
          ) : (
            <CloseSchoolYearForm
              fiscalYear={fiscalYear}
              gradeOptions={gradeOptions}
              onSubmit={this.closeTheSchoolYear}
              loading={this.state.loading}
              initialValues={{
                [CloseSchoolYearFormEnum.DoNotDeleteWithdrawnWithBalance]: false,
                [CloseSchoolYearFormEnum.ShouldDeleteGrade]: false,
                [CloseSchoolYearFormEnum.GradeIds]: [],
              }}
            />
          )}
        </TitledCard>
      </Main>
    );
  }
}

const mapDispatchToProps = {
  setYesNoDialogProps,
  getGradesAction,
};

const mapStateToProps = state => {
  return {
    gradeOptions: makeOptionsData(getGrades(state), {
      keyKey: 'Id',
      valueKey: 'Id',
      textKeys: ['Id', 'Description'],
    }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CloseSchoolYear);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/components/CloseSchoolYear.js